module.exports = __webpack_public_path__ + "img/hjordhejmen_small.0f35df88.png";